import { PU40Report } from "@/components/verizon/PU40Report";
import { PulseCheckReport } from "@/components/verizon/PulseCheckReport";
import { AVBReport } from "@/components/verizon/AVBReport";
import { DealerReportHistory } from "@/components/verizon/DealerReportHistory";
import { useCallback, useEffect, useState } from "react";
import { DealerLayout } from "@/components/shared/DealerLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { getVzDealerSummary } from "@/lib/verizonSalesApi";
import { VerizonSalesView, LastSyncBadge } from "@/components/verizon/VerizonSalesView";
import { SalesPeriodBar, PRESETS } from "@/components/verizon/SalesPeriodBar";

const rangeOf = (p, cur) => {
  if (p.preset === "custom" || !cur) return [p.start, p.end];
  return PRESETS.find((x) => x.key === p.preset).range(cur);
};

export default function DealerVerizonSales() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState({ preset: "this_month", start: null, end: null, compare: false });
  const cur = summary?.period?.current_month;

  const load = useCallback(() => {
    const [start, end] = rangeOf(period, cur);
    setLoading(true);
    getVzDealerSummary({ ...(start ? { start, end } : {}), compare: period.compare })
      .then(setSummary)
      .catch(() => toast.error("Failed to load your sales"))
      .finally(() => setLoading(false));
  }, [period, cur]);
  useEffect(() => { load(); }, [load]);

  const changePeriod = (p) => {
    if (p.preset === "custom" && (!p.start || !p.end)) {
      const [s, e] = rangeOf(period, cur);
      p = { ...p, start: p.start || s, end: p.end || e };
    }
    setPeriod(p);
  };

  return (
    <DealerLayout title="Dealer Sales">
      <div className="space-y-5" data-testid="dealer-verizon-sales-page">
        {!summary ? <div className="py-20 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-teal" /></div> : (
          <>
            <div className="flex items-center gap-3 flex-wrap">
              <LastSyncBadge lastSync={summary.last_sync} />
              {loading && <Loader2 className="w-4 h-4 animate-spin text-teal" data-testid="vz-period-loading" />}
            </div>
            <SalesPeriodBar value={period} months={summary.period?.available_months || []} onChange={changePeriod} />
            {summary.stores.length > 0 ? <VerizonSalesView summary={summary} mode="dealer" onChanged={load} /> : (
              <Card className="border-dashed" data-testid="vz-dealer-empty"><CardContent className="py-12 text-center text-slate-600">
                No sales found for your stores in {summary.period?.label || "this period"}. If you think this is wrong, ask Prime Media to link your store's TSP ID.
              </CardContent></Card>
            )}
            <PU40Report mode="dealer" />
            <AVBReport mode="dealer" />
            <PulseCheckReport mode="dealer" />
            <DealerReportHistory />
          </>
        )}
      </div>
    </DealerLayout>
  );
}
